// The delay between the message switch
export const MESSAGE_SWITCH_DELAY = 1000
export const MAX_EVENT_LIMIT = 4
